import { Component, Input, Output, EventEmitter } from '@angular/core'
import { Api } from '../../providers/api'

@Component({
  selector: 'app-recovery-link-modal',
  templateUrl: './recovery-link-modal.component.html',
  styleUrls: ['./recovery-link-modal.component.css']
})
export class RecoveryLinkModalComponent {

  @Input() email = ''
  loading = false
  mensaje = ''
  exito = false
  recoveryLink = ''
  copiado = false

  @Output() onClose = new EventEmitter<void>()

  constructor(private api: Api) {}

  generar(): void {
    if (!this.email || this.loading) return

    this.loading = true
    this.mensaje = ''
    this.recoveryLink = ''
    this.copiado = false

    this.api.createRecoveryLink(this.email).subscribe((res: any) => {
      this.loading = false
      if (res.link) {
        this.recoveryLink = res.link
        this.mensaje = 'Link de recuperación generado correctamente.'
        this.exito = true
      } else {
        this.mensaje = res.message || 'Link de recuperación generado.'
        this.exito = true
      }
    }, (err) => {
      this.loading = false
      this.mensaje = (err.error && err.error.message) || 'Error al generar el link de recuperación.'
      this.exito = false
    })
  }

  copiarLink(input: HTMLInputElement): void {
    input.select()
    document.execCommand('copy')
    this.copiado = true
    setTimeout(() => this.copiado = false, 2000)
  }

  cerrar(): void {
    this.onClose.emit()
  }
}


// WEBPACK FOOTER //
// ./src/app/admin/recovery-link-modal/recovery-link-modal.component.ts